import React, { useEffect, useMemo, useState, forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup, Col, Dropdown, DropdownButton, Form, Row } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash, faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import AdvanceTableWrapper from 'components/common/tables/AdvanceTableWrapper';
import AdvanceTable from 'components/common/tables/AdvanceTable';
import AdvanceTablePagination from 'components/common/tables/AdvanceTablePagination';
import AdvanceTableSearchBox from 'components/common/tables/AdvanceTableSearchBox';
/* import IconButton from 'components/common/IconButton'; */

const IndeterminateCheckbox = forwardRef(({ indeterminate, ...rest }, ref) => {
 const defaultRef = useRef();
 const resolvedRef = ref || defaultRef;

 useEffect(() => {
  resolvedRef.current.indeterminate = indeterminate;
 }, [resolvedRef, indeterminate]);

 return <input type="checkbox" id="All" ref={resolvedRef} {...rest} className="form-check-input m-1" />;
});

const BulAction = ({
 selectedRowIds,
 globalFilter,
 setGlobalFilter,
 //groupBy,
 //expanded,
 allColumns,
 getToggleHideAllColumnsProps,
 /* resetData, */
 updateMyData
}) => {
 //console.log({ selectedRowIds, allColumns }, Object.keys(selectedRowIds));
 const [select, setSelect] = useState(null);
 const updateData = () => {
  if (select === 'delete') updateMyData(null, null, Object.keys(selectedRowIds), 3);
  else if (select !== 'Acciones masivas') updateMyData(Object.keys(selectedRowIds), 'status', select);
  setSelect(null);
 };
 // ms-auto text-end
 return (
  <Row className="flex-between-center mb-3">
   <Col xs={2} sm="auto" className="d-flex align-items-center pe-0">
    <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">
     {/* {Object.keys(selectedRowIds).length > 1 ? (
      'Ha seleccionado ' + Object.keys(selectedRowIds).length + ' filas'
     ) : Object.keys(selectedRowIds).length > 0 ? (
      'Ha seleccionado 1 fila'
     ) : (
      <pre>
       <code>{JSON.stringify({ groupBy, expanded }, null, 2)}</code>
      </pre>
     )} */}
     ...
    </h5>
   </Col>
   <Col xs={10} sm="auto" className="ps-0">
    {Object.keys(selectedRowIds).length > 0 ? (
     <div className="d-flex">
      <Form.Select size="sm" aria-label="Bulk actions" onChange={e => setSelect(e.target.value)}>
       <option>Acciones masivas</option>
       <option value="Available">Disponible</option>
       <option value="Inactive">Inactivo</option>
       <option value="delete">Eliminar</option>
      </Form.Select>
      <Button type="button" variant="falcon-default" size="sm" className="ms-2" onClick={updateData}>
       Apply
      </Button>
     </div>
    ) : (
     <Flex id="orders-actions" wrap="wrap-reverse" justifyContent="end">
      <div className="p-1 flex-grow-1">
       <AdvanceTableSearchBox globalFilter={globalFilter} setGlobalFilter={setGlobalFilter} placeholder="buscandooooo..." />
      </div>

      <div className="p-1">
       <DropdownButton
        as={ButtonGroup}
        size="sm"
        id={'dropdown-variants'}
        variant="falcon-default"
        title={
         <>
          <FontAwesomeIcon icon={faEyeSlash} className="me-1" transform="shrink-3" />
          <span className="d-none d-sm-inline-block">Ocultar</span>
         </>
        }
       >
        <Dropdown.ItemText>Oculta columnas de la tabla</Dropdown.ItemText>
        <div className="dropdown-item cursor-pointer">
         <div className="cursor-pointer mb-0 form-check p-0">
          <IndeterminateCheckbox {...getToggleHideAllColumnsProps()} />
          <label title="Toggle Column Visible" htmlFor="All" className="form-check-label m-0">
           Todos
          </label>
         </div>
        </div>

        <Dropdown.Divider />
        {allColumns.map(column => (
         <div key={column.id} className="dropdown-item cursor-pointer">
          <div className="cursor-pointer mb-0 form-check p-0">
           <input type="checkbox" id={column.id} className="form-check-input m-1" {...column.getToggleHiddenProps()} />
           <label title="Toggle Column Visible" htmlFor={column.id} className="form-check-label m-0">
            {column.id}
           </label>
          </div>
         </div>
        ))}
       </DropdownButton>
      </div>

      <div className="p-1">
       <DropdownButton
        as={ButtonGroup}
        size="sm"
        id={'dropdown-variants'}
        variant="falcon-default"
        title={
         <>
          <FontAwesomeIcon icon={faLayerGroup} className="me-1" transform="shrink-3" />
          <span className="d-none d-sm-inline-block">Agrupar</span>
         </>
        }
       >
        <Dropdown.ItemText>Oculta columnas de la tabla</Dropdown.ItemText>
        {allColumns.map(column => (
         <div key={column.id} className="dropdown-item cursor-pointer">
          <div className="cursor-pointer mb-0 form-check p-0">
           <input type="checkbox" id={column.id} className="form-check-input m-1" {...column.getGroupByToggleProps()} />
           <label title="Toggle Column Visible" htmlFor={column.id} className="form-check-label m-0">
            {column.id}
           </label>
          </div>
         </div>
        ))}
       </DropdownButton>
      </div>
      {/* <div className="p-1">
       <IconButton
        variant="falcon-default"
        size="sm"
        icon="sync-alt"
        transform="shrink-3"
        //className="ms-2"
        onClick={() => resetData()}
       >
        <span className="d-none d-sm-inline-block">Reset</span>
       </IconButton>
      </div> */}
     </Flex>
    )}
   </Col>
  </Row>
 );
};

function roundedMedian(leafValues) {
 let min = leafValues[0] || 0;
 let max = leafValues[0] || 0;

 leafValues.forEach(value => {
  min = Math.min(min, value);
  max = Math.max(max, value);
 });

 return Math.round((min + max) / 2);
}

const TableTerrains = ({ data, setData, product, setProduct }) => {
 const [skipPageReset, setSkipPageReset] = useState(false);
 const [editableRowIndex, setEditableRowIndex] = useState({
  currentIndex: null,
  data: null
 });

 const columns = useMemo(
  () => [
   {
    accessor: 'blocks',
    Header: 'Bloque',
    maxWidth: 50,
    aggregate: 'count',
    Aggregated: ({ value }) => `${value} Bloques`
   },
   {
    accessor: 'stage',
    Header: 'Etapa',
    maxWidth: 50,
    aggregate: 'count',
    Aggregated: ({ value }) => `${value} Bloques`
   },
   {
    accessor: 'num',
    Header: 'Lote',
    /* Cell: rowData => {
              //const { num } = rowData.row.original;
              //console.log(rowData);
              return rowData?.row?.original?.num ? (
                <Form.Control
                  type="text"
                  name="num"
                  autoComplete="off"
                  disabled={false}
                  maxLength={20}
                  size="sm"
                  defaultValue={rowData?.row?.original?.num}
                  onFocus={() => console.log('puso el foco')}
                  onChange={e => console.log(e.target)}
                />
              ) : (
                <></>
              );
            }, */
    aggregate: 'uniqueCount',
    Aggregated: ({ value }) => `${value} Unique Names`
   },
   {
    accessor: 'area',
    Header: 'Area',
    cellProps: {
     className: 'fw-medium'
    },
    aggregate: 'average',
    Aggregated: ({ value }) => `${Math.round(value * 100) / 100} (avg)`
   },
   {
    accessor: 'mtr',
    Header: 'Mtr2',
    aggregate: 'sum',
    Aggregated: ({ value }) => `${value} (total)`
   },
   {
    accessor: 'price',
    Header: 'Valor',
    /* Cell: function Cell(cell) {
              return <span>{cell.value}</span>;
            },
            Cell: rowData => {
            const { email } = rowData.row.original;
            return <a href={'mailto:' + email}>{email}</a>;
          } */
    // Use our custom roundedMedian aggregator
    aggregate: roundedMedian,
    Aggregated: ({ value }) => `${value} (med)`
   },
   {
    accessor: 'status',
    Header: 'Estado',
    cellProps: {
     className: 'fw-medium'
    }
   },
   {
    accessor: 'type',
    Header: 'Financiamiento',
    cellProps: {
     className: 'fw-medium'
    }
   },
   {
    accessor: 'description',
    Header: 'Descripcion'
   },
   {
    accessor: 'purlieu',
    Header: 'Linderos'
    /* Cell: rowData => {
            const { email } = rowData.row.original;
            return <a href={'mailto:' + email}>{email}</a>;
          } */
   } /* ,
          {
            Header: 'Accion',
            Cell: rowData => {
              //const { num } = rowData.row.original;
              return rowData?.row?.original?.num ? (
                <CardDropdown>
                  <div className="py-2">
                    <Dropdown.Item
                      className="text-primary"
                    >
                      Edit
                    </Dropdown.Item>
                    <Dropdown.Item
                      className="text-danger"
                    >
                      Remove
                    </Dropdown.Item>
                  </div>
                </CardDropdown>
              ) : (
                <></>
              );
            },
            aggregate: 'uniqueCount',
            Aggregated: ({ value }) => `${value} Unique Names`
          } */
  ],
  []
 );

 // Necesitamos evitar que la tabla reinicie el índice de página cuando
 // Actualizar datos. Entonces podemos hacer un seguimiento de esa bandera con una referencia.

 // Cuando nuestro renderizador de celda llame a updateMyData, usaremos
 // el índice de fila, el ID de columna y el nuevo valor para actualizar el
 // datos originales

 const updateMyData = (index, column, value, type = 0) => {
  // También activamos la bandera para no resetear la página
  setSkipPageReset(true);
  const indices = Array.isArray(index) ? index : [];

  if (type === 1) setData(old => old.map((row, i) => (i === index ? { ...old[i], ...value } : row)));
  else if (type === 2) setData(old => old.concat([value]));
  else if (type === 3) setData(old => old.filter((_, i) => !value.some(e => e == i)));
  else setData(old => old.map((row, i) => (i === index || indices.some(e => e == i) ? { ...old[i], [column]: value } : row)));
 };

 const getRowProps = row => row.index === editableRowIndex.currentIndex && { className: 'table-primary' };

 // After data chagnes, we turn the flag back off
 // so that if data actually changes when we're not
 // editing it, the page is reset

 useEffect(() => {
  if (editableRowIndex?.currentIndex > -1) {
   setSkipPageReset(true);
   setProduct(editableRowIndex);
  }
 }, [editableRowIndex.currentIndex]);

 useEffect(() => {
  if (!product) setEditableRowIndex({ currentIndex: null, data: null });
 }, [product]);

 // Let's add a data resetter/randomizer to help
 // illustrate that flow...
 const resetData = () => {
  console.log('no hay nada que resetear');
  //setData({ ...data, products: originalData });
 };

 return (
  <AdvanceTableWrapper
   columns={columns}
   data={data}
   sortable
   pagination
   perPage={5}
   selection
   selectionColumnWidth={30}
   updateMyData={updateMyData}
   skipPageReset={skipPageReset}
   getRowProps={getRowProps}
   editableRowIndex={editableRowIndex}
   setEditableRowIndex={setEditableRowIndex}
   resetData={resetData}
  >
   <BulAction table />
   <AdvanceTable
    table
    headerClassName="bg-200 text-900 text-nowrap align-middle"
    rowClassName="align-middle white-space-nowrap"
    tableProps={{
     striped: true,
     className: 'fs--1 mb-0 overflow-hidden',
     responsive: true,
     hover: true,
     size: 'sm'
    }}
   />
   <div className="mt-3">
    <AdvanceTablePagination table />
   </div>
  </AdvanceTableWrapper>
 );
};

IndeterminateCheckbox.propTypes = { indeterminate: PropTypes.any };

BulAction.propTypes = {
 selectedRowIds: PropTypes.object,
 globalFilter: PropTypes.any,
 setGlobalFilter: PropTypes.any,
 groupBy: PropTypes.any,
 expanded: PropTypes.any,
 allColumns: PropTypes.any,
 getToggleHideAllColumnsProps: PropTypes.any,
 resetData: PropTypes.any,
 updateMyData: PropTypes.func
};

TableTerrains.propTypes = {
 data: PropTypes.array,
 setData: PropTypes.func,
 product: PropTypes.object,
 setProduct: PropTypes.func
};

export default TableTerrains;
